import type { KeyboardEventHandler } from 'react';

// Prevent enter from submitting the form when pressed inside input fields,
// but allow enter on buttons so keyboard users can activate them.
export const preventDefaultEnterSubmit: KeyboardEventHandler = (event) => {
  const target = event.target as HTMLElement;
  if (event.key === 'Enter' && target.tagName !== 'BUTTON') {
    event.preventDefault();
  }
};
